import React from 'react';
import { useLocation } from 'react-router';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { vehicleType } from 'Utilities/helpers';

import { Content } from 'LegacySBCRA/Content/Content';

import { usePageRefEvents } from '../../common/Hooks/usePageRefEvents';
import useBrandName from '../hooks/useBrandName';

import LocalTexts from './DealerLogos.json';

import styles from './DealerLogos.scss';

const LocalT = new MDText(LocalTexts);

export const getDealerLogoSrc = (dealerName: string, extension: string = 'svg') => dealerName && `/dealerLogos/${dealerName}-grey.${extension}`;

const dealerLogosData = [
  {
    dealerName: 'Sytner', height: 64, id: 1, width: 201,
  },
  {
    dealerName: 'EvansHalshaw', height: 64, id: 2, width: 202,
  },
  {
    dealerName: 'Jardine', height: 41, id: 3, width: 139,
  },
  {
    dealerName: 'ThurlowNunn', height: 56, id: 4, width: 176,
  },
  {
    dealerName: 'Inchcape', height: 64, id: 5, width: 202,
  },
];

const dealerLogos = dealerLogosData.map(({ dealerName, ...restAttributes }) => ({
  ...restAttributes,
  alt: `${dealerName} Icon`,
  src: getDealerLogoSrc(dealerName),
}));

type DealerLogosProps = {
  className?: string;
  onLoad?: () => void;
}

const DealerLogos = ({ className, onLoad = () => {} }: DealerLogosProps) => {
  const brandName = useBrandName();
  const location = useLocation();

  const { setRef } = usePageRefEvents({ onRefTrigger: onLoad });

  return (
    <Content className={styles.component} element="section" wrapper={{ className: cx(styles.componentWrapper, className) }}>
      <h3>
        {LocalT.translate('title', { vehicle: brandName || vehicleType(location.pathname) })}
      </h3>
      <div
        ref={(ref) => setRef(ref)}
        className={styles.logos}
        data-testid='dealerLogos'
      >
        {dealerLogos.map(({
          alt, height, id, src, width,
        }) => (
          <div key={id} className={cx(styles.logo, styles[`logo${id + 1}`])}>
            <img alt={alt} height={height} loading="lazy" src={src} width={width} />
          </div>
        ))}
      </div>
    </Content>
  );
};

export default DealerLogos;
